// angular
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

// libs
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';

import {ActivePromotionConfig} from '../../config/active-promotion.config';

// module
import {DataService} from '@cosbeni/database';
import {ActionTypes, LoadUserFailureAction, LoadUserSuccessAction} from '../actions/user.action';

@Injectable()
export class UserEffects {

  loadUser$ = createEffect(() => this.actions$.pipe(
    ofType(ActionTypes.LOAD_USER),
    switchMap(() => {
      const url = ActivePromotionConfig.SERVER_URL;
      return this.dataService.user({}, url).pipe(
        map((response) => new LoadUserSuccessAction(response)),
        catchError(() => {
          this.router.navigate(['login'], {});
          return of(new LoadUserFailureAction());
        }),
      );
    })));

  constructor(private actions$: Actions,
              private dataService: DataService,
              private router: Router) {
  }
}
